import { render, staticRenderFns } from "./CompraCrud.vue?vue&type=template&id=7534f5ac"
import script from "./CompraCrud.vue?vue&type=script&lang=js"
export * from "./CompraCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports